import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, createSearchParams } from 'react-router-dom';
import {
  Box,
  Title,
  Group,
  Text,
  Stack,
  Image,
  Card,
  Container,
  SimpleGrid,
  SegmentedControl,
} from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { CircleX } from 'tabler-icons-react';
import { useTranslation } from 'react-i18next';
import { sendRequest } from '../../services/services';

import AppContext from '../../components/Context/index';

import LogoH from '../../image/mawqfi-logo-h.svg';
import QRCode from '../../image/QRCode.svg';
import Ticket from '../../image/ticket.svg';
import CarPlate from '../../image/car-plate.svg';
import Ad from '../../image/ad-0.png';

const Home = () => {
  const navigate = useNavigate();
  const [ticketNumber, setTicketNumber] = useState();
  const appContextState = useContext(AppContext);
  const { appState, setAppState } = appContextState;
  const siteDetails = JSON.parse(localStorage.getItem('siteDetails'));
  const { t } = useTranslation();

  // switch control change to language arabic and english
  const changeLanguageHandler = (value) => {
    window.location.reload();
    setAppState({ language: value });
  };

  const [barcodeRead, setBarcodeRead] = useState('');

  const barcode = {
    timing: 1000,
    data: '',
  };

  const barcodeReaded = () => {
    if (barcode.data.length > 1) {
      setBarcodeRead(barcode.data);
    } else {
      barcode.data = '';
    }
  };

  let timeout = setTimeout(barcodeReaded, 500);

  // recoganize the data of barcode scanning
  useEffect(() => {
    window.addEventListener('keypress', (e) => {
      if (barcode.data.length === 0 || e.timeStamp - barcode.timing < 1000) {
        barcode.data += e.key;
        barcode.timing = e.timeStamp;
        clearTimeout(timeout);
        timeout = setTimeout(barcodeReaded, 500);
      } else {
        barcode.data = '';
      }
    });
  }, []);

  useEffect(() => {
    const urlValue = barcodeRead;
    const str = urlValue
      .trim()
      .split('/')
      .pop()
      .replace(/[^0-9]/g, '');

    setTicketNumber(str);

    setTicketNumber(str);
    if (ticketNumber) {
      sendRequest(`parking/site-id-by-pass-id/${ticketNumber}`, 'get').then((data) => {
        if (data?.data?.site_id === siteDetails?.siteId) {
          sendRequest(`parking/reservations-by-pass-id/${ticketNumber}`, 'get').then((res) => {
            if (res?.code === 20) {
              navigate({
                pathname: '/addVas',
                search: createSearchParams({
                  passId: ticketNumber,
                }).toString(),
              });
            } else if (res?.code === 21) {
              showNotification({
                title: <Text weight={500}>{t('enter.invalid.ticket.number')}</Text>,
                icon: <CircleX size={16} />,
              });
            }
          });
        } else if (data?.data?.site_id !== siteDetails?.siteId) {
          showNotification({
            title: <Text weight={500}>{t('enter.invalid.site.id')}</Text>,
            icon: <CircleX size={16} />,
          });
        }
      });
    }
  }, [ticketNumber, barcodeRead]);

  localStorage.removeItem('selectedVas');

  return (
    <Box style={{ height: 'calc(100vh - 48px)', margin: '24px 0' }}>
      <Container
        className="home"
        style={{ display: 'flex', alignItems: 'stretch', flexDirection: 'column', height: '100%' }}
      >
        <Group position="apart" style={{ marginBottom: '2%' }}>
          <Image src={LogoH} height={64} />
          <SegmentedControl
            radius="xl"
            size="md"
            color="cyan"
            value={appState?.language}
            onChange={changeLanguageHandler}
            data={[
              { value: 'ar', label: 'العربية' },
              { value: 'en', label: 'English' },
            ]}
          />
        </Group>
        <Stack>
          {appState?.language === 'ar' ? (
            <Title style={{ color: '#2C5864', margin: '2% 0' }} order={3}>
              اختر طريقة حتى تتمكن من سداد تذكرتك
            </Title>
          ) : (
            <Title style={{ color: '#2C5864', margin: '3% 0' }} order={3}>
              Choose a method so you can pay for your ticket
            </Title>
          )}
        </Stack>
        <Stack style={{ height: '100%' }}>
          <Group position="apart" style={{ height: '100%', width: '100%' }}>
            <Stack style={{ height: '100%' }}>
              <div className="parent">
                <div className="div1">
                  <Card
                    shadow="sm"
                    p="lg"
                    className="border-radius-start"
                    style={{
                      display: 'flex',
                      height: '100%',
                      justifyContent: 'center',
                      flexDirection: 'column',
                      alignContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    {appState?.language === 'ar' ? (
                      <Stack>
                        <Image src={QRCode} width="77%" />
                        <Text weight={500} align="center" style={{ color: '#2C5864' }}>
                          {' '}
                          ضع رمز الاستجابة
                          <br /> السريعة الخاص بك
                          <br /> أمام كاميرا{' '}
                        </Text>
                      </Stack>
                    ) : (
                      <Stack>
                        <Image src={QRCode} width="77%" />
                        <Text weight={500} align="center" style={{ color: '#2C5864' }}>
                          {' '}
                          Put the response code
                          <br /> your quick
                          <br /> in front of a camera{' '}
                        </Text>
                      </Stack>
                    )}
                  </Card>
                </div>
                <div className="div2">
                  <Card
                    shadow="sm"
                    p="lg"
                    className="border-radius-top-end"
                    onClick={() => navigate('/numberplate')}
                  >
                    {appState?.language === 'ar' ? (
                      <Stack>
                        <Image src={CarPlate} width="60%" />
                        <Text weight={500} align="center" style={{ color: '#2C5864' }}>
                          {' '}
                          أدخل رقم لوحة السيارة{' '}
                        </Text>
                      </Stack>
                    ) : (
                      <Stack>
                        <Image src={CarPlate} width="60%" />
                        <Text weight={500} align="center" style={{ color: '#2C5864' }}>
                          {' '}
                          Enter the license plate number{' '}
                        </Text>
                      </Stack>
                    )}
                  </Card>
                </div>
                <div className="div3">
                  <Card
                    shadow="sm"
                    p="lg"
                    className="border-radius-bottom-end"
                    onClick={() => navigate('/ticketnumber')}
                  >
                    {appState?.language === 'ar' ? (
                      <Stack>
                        <Image src={Ticket} width="60%" />
                        <Text weight={500} align="center" style={{ color: '#2C5864' }}>
                          {' '}
                          أدخل رقم التذكرة{' '}
                        </Text>
                      </Stack>
                    ) : (
                      <Stack>
                        <Image src={Ticket} width="60%" />
                        <Text weight={500} align="center" style={{ color: '#2C5864' }}>
                          {' '}
                          Enter the ticket number{' '}
                        </Text>
                      </Stack>
                    )}
                  </Card>
                </div>
              </div>
            </Stack>
            <Stack style={{ height: '100%' }}>
              <SimpleGrid cols={1} style={{ placeContent: 'end', padding: '0' }}>
                <Card
                  shadow="sm"
                  p="lg"
                  style={{
                    display: 'flex',
                    borderRadius: '24px',
                    height: '100%',
                    padding: '0',
                    placeContent: 'end',
                    justifyContent: 'center',
                    flexDirection: 'column',
                    alignContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Stack>
                    <Image src={Ad} style={{ maxWidth: '220px' }} />
                  </Stack>
                </Card>
              </SimpleGrid>
            </Stack>
          </Group>
        </Stack>
      </Container>
    </Box>
  );
};

export default Home;
